'use client';

import { useEffect, useState } from 'react';
import { AdminDashboard } from './admin-dashboard';
import { TicketDetail } from './ticket-detail';
import {
  Container,
  Title,
  Text,
  Button,
  MediaQuery,
  Flex
} from '@mantine/core';
import {
  getHeader,
  getUserData,
  getUserType
} from '../../../config/userSession';
import { SupportModal } from '../../../layouts/header/support-modal';

// Mock data for demonstration

export default function AdminPage() {
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [supportModalOpened, setSupportModalOpened] = useState(false);
  const userDetails = getUserData();
  const userType = getUserType();
  const handleGetSupportTickets = async (values) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/account/get-support-requests`,
        {
          method: 'GET',
          headers: getHeader()
        }
      );

      const result = await response.json();
      console.log(result);
      setTickets(result.response);
      if (!response.ok) {
        throw new Error(result.message || 'Failed to send email');
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  useEffect(() => {
    handleGetSupportTickets();
  }, []);
  const handleUpdateTicket = (ticketId, updates) => {
    setTickets((prev) =>
      prev.map((ticket) =>
        ticket.id === ticketId ? { ...ticket, ...updates } : ticket
      )
    );

    if (selectedTicket?.id === ticketId) {
      setSelectedTicket((prev) => (prev ? { ...prev, ...updates } : null));
    }
  };

  const handleAddResponse = (ticketId, response) => {
    const newResponse = {
      ...response,
      id: `resp-${Date.now()}`,
      createdAt: new Date()
    };

    setTickets((prev) =>
      prev.map((ticket) =>
        ticket.id === ticketId
          ? {
              ...ticket,
              responses: [...ticket.responses, newResponse],
              updatedAt: new Date()
            }
          : ticket
      )
    );

    if (selectedTicket?.id === ticketId) {
      setSelectedTicket((prev) =>
        prev
          ? {
              ...prev,
              responses: [...prev.responses, newResponse],
              updatedAt: new Date()
            }
          : null
      );
    }
  };
  const handleOpenSupport = () => {
    setSupportModalOpened(true);
  };
  if (selectedTicket) {
    return (
      <Container size="lg" px="lg" py="lg">
        <TicketDetail
          ticket={selectedTicket}
          onBack={() => setSelectedTicket(null)}
          handleGetSupportTickets={handleGetSupportTickets}
        />
      </Container>
    );
  }
  return (
    <Container size="lg" px="lg" py="lg">
      <Flex justify="space-between" align="center" mb="md">
        <Title order={1}>Support Requests</Title>

        {(userType === 'Landlord' || userType === 'Tenant') && (
          <MediaQuery query="(max-width: 500px)" styles={{ display: 'none' }}>
            <Button
              onClick={handleOpenSupport}
              color="secondary.0"
              radius="100px"
              size="lg"
            >
              Create Support Request
            </Button>
          </MediaQuery>
        )}
      </Flex>
      <AdminDashboard tickets={tickets} onSelectTicket={setSelectedTicket} />
      <SupportModal
        email={userDetails?.email}
        opened={supportModalOpened}
        onClose={() => setSupportModalOpened(false)}
        reload={handleGetSupportTickets}
      />
    </Container>
  );
}
